module.exports = __webpack_public_path__ + "img/ics_o_boat.592fda61.svg";